/**
 * Checks if a given set is a subset of the elements in another set produced from an array.
 * Important note: Set.prototype.isSubsetOf is a new feature (as of time of writing, June 2025)
 * and transpilers are not happy about it yet.
 * @param {Array<T>} array - The array to check against.
 * @param {Set<T>} set - The set to check if it is a subset of the array.
 * @returns {boolean} - Returns true if the set is a subset of the array, false otherwise.
 */
export function isSetSubsetOfArray<T>(set: Set<T>, array: Array<T>): boolean {
  const setProducedFromArray = new Set(array);

  return Array.from(set).every((setMember) =>
    setProducedFromArray.has(setMember),
  );
}
